import React from 'react';
import Icon from 'components/AppIcon';

export default function SpendingAlerts({ categories, loading }) {
  const items = categories || [];

  const alerts = items?.filter((c) => {
      const spent = parseFloat(c?.spent) || 0;
      const limit = parseFloat(c?.monthly_limit) || 1;
      return (spent / limit) >= 0.7;
    })?.map((c) => {
      const spent = parseFloat(c?.spent) || 0;
      const limit = parseFloat(c?.monthly_limit) || 1;
      const pct = Math.round((spent / limit) * 100);
      const isOver = spent > limit;
      return {
        id: c?.id,
        category: c?.name,
        icon: c?.icon || 'Tag',
        color: isOver ? '#EF4444' : '#F59E0B',
        bgColor: isOver ? 'rgba(239,68,68,0.08)' : 'rgba(245,158,11,0.08)',
        borderColor: isOver ? 'rgba(239,68,68,0.2)' : 'rgba(245,158,11,0.2)',
        message: isOver
          ? `Over budget by $${(spent - limit)?.toFixed(0)}`
          : `${pct}% of budget used`,
        severity: isOver ? 'error' : 'warning',
      };
    });

  if (loading) {
    return (
      <div className="flex gap-3 overflow-x-auto pb-1">
        {[1, 2]?.map((i) => (
          <div key={i} className="h-12 w-48 flex-shrink-0 bg-[#1E3A5F] rounded-xl animate-pulse" />
        ))}
      </div>
    );
  }

  if (alerts?.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-3">
      {alerts?.map((alert) => (
        <div
          key={alert?.id}
          className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl border"
          style={{ backgroundColor: alert?.bgColor, borderColor: alert?.borderColor }}
        >
          <Icon name={alert?.severity === 'error' ? 'AlertTriangle' : 'AlertCircle'} size={14} color={alert?.color} />
          <div>
            <p className="text-xs font-medium" style={{ color: alert?.color }}>{alert?.category}</p>
            <p className="text-xs text-[#94A3B8]">{alert?.message}</p>
          </div>
        </div>
      ))}
    </div>
  );
}